import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
/**
 * The derived unit for catalytic activity ( <code>kat</code> ).
 */
export var Katal = UnitDivide.amountOfSubstanceByDuration("Katal", BaseUnits.Mole, BaseUnits.Second);
//# sourceMappingURL=catalytic-activity.js.map